import { render, staticRenderFns } from "./newpushbuttoneventtype.vue?vue&type=template&id=4bc66d42&scoped=true"
import script from "./newpushbuttoneventtype.vue?vue&type=script&lang=js"
export * from "./newpushbuttoneventtype.vue?vue&type=script&lang=js"
import style0 from "./newpushbuttoneventtype.vue?vue&type=style&index=0&id=4bc66d42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc66d42",
  null
  
)

export default component.exports